import { styled } from '@mui/material/styles';
import { Autocomplete, Popper } from '@mui/material';

export const LightAutocomplete = styled(Autocomplete)(({ theme }) => ({
    minWidth: '18rem',
    backgroundColor: theme.palette.selector.primary,
    '& .MuiOutlinedInput-root': {
        color: theme.palette.primary.contrastText,
        '& fieldset': {
            borderColor: theme.palette.selector.default,
        },
        '&:hover fieldset': {
            borderColor: theme.palette.selector.default,
        },
        '& input': {
            minWidth: 0,
            maxWidth: '80%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flexShrink: 1,
        },
    },
    '& .MuiSvgIcon-root': {
        color: theme.palette.selector.default,
    },
    '& .MuiFormLabel-root': {
        color: theme.palette.primary.contrastText,
        '&.Mui-focused': {
            color: theme.palette.primary.contrastText,
        },
    },

    [theme.breakpoints.down('sm')]: {
        minWidth: '2rem',
    },
}));

export const StyledPopper = styled(Popper)(({ theme }) => ({
    '& .MuiAutocomplete-listbox': {
        fontSize: theme.typography.pxToRem(13),
    },
}));
